module.exports = __webpack_public_path__ + "static/ranking1.229c5144.svg";